(function () {
  "use strict";

  var CART_SECTION = "cart-drawer";

  /* ---------------- Toast ---------------- */
  function toast(message, variant) {
    var root = document.getElementById("ToastRoot");
    if (!root) return;
    var el = document.createElement("div");
    el.className =
      "pointer-events-auto rounded-lg px-4 py-3 shadow-lg text-sm font-body font-medium transition-all duration-300 translate-y-[-8px] opacity-0 " +
      (variant === "error"
        ? "bg-destructive text-destructive-foreground"
        : "bg-primary text-primary-foreground");
    el.textContent = message;
    root.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.remove("translate-y-[-8px]", "opacity-0");
    });
    setTimeout(function () {
      el.classList.add("opacity-0");
      setTimeout(function () {
        el.remove();
      }, 300);
    }, 2600);
  }

  /* ---------------- Mobile menu ---------------- */
  function initMobileMenu() {
    var toggle = document.querySelector("[data-mobile-toggle]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (!toggle || !menu) return;
    var iconMenu = toggle.querySelector("[data-icon-menu]");
    var iconClose = toggle.querySelector("[data-icon-close]");
    toggle.addEventListener("click", function () {
      var open = menu.classList.toggle("hidden") === false;
      toggle.setAttribute("aria-expanded", String(open));
      if (iconMenu) iconMenu.classList.toggle("hidden", open);
      if (iconClose) iconClose.classList.toggle("hidden", !open);
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer, panel, overlay;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.remove("hidden");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    requestAnimationFrame(function () {
      if (panel) panel.classList.remove("translate-x-full");
      if (overlay) overlay.classList.remove("opacity-0");
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    if (panel) panel.classList.add("translate-x-full");
    if (overlay) overlay.classList.add("opacity-0");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    setTimeout(function () {
      drawer.classList.add("hidden");
    }, 300);
  }

  function refreshDrawerRefs() {
    drawer = document.querySelector("[data-cart-drawer]");
    panel = drawer ? drawer.querySelector("[data-cart-panel]") : null;
    overlay = drawer ? drawer.querySelector("[data-cart-overlay]") : null;
  }

  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.classList.toggle("hidden", count === 0);
    });
  }

  function replaceCartContents(sectionHtml) {
    if (!sectionHtml) return;
    var parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
    var fresh = parsed.querySelector("[data-cart-contents]");
    var current = document.querySelector("[data-cart-contents]");
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var freshSub = parsed.querySelector("[data-cart-subtitle]");
    var curSub = document.querySelector("[data-cart-subtitle]");
    if (freshSub && curSub) curSub.innerHTML = freshSub.innerHTML;
  }

  function cartRequest(url, body) {
    body.sections = [CART_SECTION];
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        return { ok: r.ok, status: r.status, data: data };
      });
    });
  }

  function applyCartResponse(res) {
    var data = res.data || {};
    if (data.sections && data.sections[CART_SECTION]) {
      replaceCartContents(data.sections[CART_SECTION]);
    }
    if (typeof data.item_count === "number") {
      updateCartCount(data.item_count);
    } else {
      // /cart/add.js returns the line item, not the cart; fetch count
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (c) { updateCartCount(c.item_count); });
    }
  }

  function changeLine(key, qty) {
    cartRequest("/cart/change.js", { id: key, quantity: qty }).then(function (res) {
      if (!res.ok) {
        toast((res.data && res.data.message) || "Could not update cart", "error");
        return;
      }
      applyCartResponse(res);
    });
  }

  function addToCart(form, btn) {
    var formData = new FormData(form);
    var body = {};
    var items = {};
    formData.forEach(function (v, k) { items[k] = v; });
    body.items = [items];

    if (btn) { btn.disabled = true; btn.dataset.loading = "true"; }

    cartRequest("/cart/add.js", body).then(function (res) {
      if (btn) { btn.disabled = false; delete btn.dataset.loading; }
      if (!res.ok) {
        toast((res.data && res.data.description) || (res.data && res.data.message) || "Could not add to cart", "error");
        return;
      }
      applyCartResponse(res);
      toast("Added to cart");
      openDrawer();
    });
  }

  function initCart() {
    refreshDrawerRefs();

    document.addEventListener("click", function (e) {
      var open = e.target.closest("[data-cart-open]");
      if (open) { e.preventDefault(); openDrawer(); return; }

      var close = e.target.closest("[data-cart-close]");
      if (close) { e.preventDefault(); closeDrawer(); return; }

      var change = e.target.closest("[data-line-change]");
      if (change) {
        e.preventDefault();
        changeLine(change.getAttribute("data-line-key"), parseInt(change.getAttribute("data-qty"), 10));
        return;
      }

      var remove = e.target.closest("[data-line-remove]");
      if (remove) {
        e.preventDefault();
        changeLine(remove.getAttribute("data-line-key"), 0);
        return;
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });

    // Intercept product add-to-cart forms
    document.querySelectorAll('form[action$="/cart/add"], form[data-product-form]').forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        addToCart(form, form.querySelector('[type="submit"]'));
      });
    });
  }

  /* ---------------- Product variant selection ---------------- */
  function initProductForm() {
    var root = document.querySelector("[data-product-root]");
    if (!root) return;

    var variants;
    try {
      variants = JSON.parse(root.querySelector("[data-variants-json]").textContent);
    } catch (e) {
      return;
    }

    var optionNames = JSON.parse(root.querySelector("[data-options-json]").textContent);
    var selected = {};

    // initialise from defaults (pre-selected single-value options)
    root.querySelectorAll("[data-option-value][data-selected='true']").forEach(function (btn) {
      selected[btn.getAttribute("data-option-name")] = btn.getAttribute("data-option-value");
    });

    var idInput = root.querySelector("[data-variant-id]");
    var priceEl = root.querySelector("[data-product-price]");
    var addBtn = root.querySelector("[data-add-btn]");
    var addLabel = root.querySelector("[data-add-label]");
    var mainImg = root.querySelector("[data-product-image]");

    function findVariant() {
      return variants.find(function (v) {
        return optionNames.every(function (name, i) {
          return v.options[i] === selected[name];
        });
      });
    }

    function allSelected() {
      return optionNames.every(function (n) { return selected[n]; });
    }

    function update() {
      var v = findVariant();
      if (priceEl && v) priceEl.textContent = v.price;
      if (idInput) idInput.value = v ? v.id : "";
      if (v && v.featured_image && mainImg) mainImg.src = v.featured_image;

      if (!addBtn) return;
      if (!allSelected()) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Select options";
      } else if (!v || !v.available) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = "Sold out";
      } else {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = "Add to Cart";
      }
    }

    root.querySelectorAll("[data-option-value]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var name = btn.getAttribute("data-option-name");
        selected[name] = btn.getAttribute("data-option-value");
        root
          .querySelectorAll('[data-option-name="' + CSS.escape(name) + '"]')
          .forEach(function (b) {
            var active = b === btn;
            b.classList.toggle("bg-primary", active);
            b.classList.toggle("text-primary-foreground", active);
            b.classList.toggle("border-primary", active);
            b.classList.toggle("bg-background", !active);
            b.classList.toggle("text-foreground", !active);
            b.classList.toggle("border-border", !active);
          });
        update();
      });
    });

    update();
  }

  /* ---------------- Contact form (client-only confirmation) ---------------- */
  function initContactForm() {
    var form = document.querySelector("[data-contact-form]");
    if (!form || form.getAttribute("data-native") === "true") return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var success = document.querySelector("[data-contact-success]");
      if (success) {
        form.classList.add("hidden");
        success.classList.remove("hidden");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMobileMenu();
    initCart();
    initProductForm();
    initContactForm();
  });
})();
